module.exports = __webpack_public_path__ + "img/hr-level2addon_idle_mask.e761729d.png";